module.exports = __webpack_public_path__ + "static/media/congratulations.c9d78030.png";